/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 
import '../../crp_meta_ui/elements/error-component.js';
import "../../crp_meta_ui/elements/dropdown-landing.js";
import './fin-auth-softtoken-otp.js';
import './fin-page-footer.js';
const template = html `
<custom-style>
  <style include="login-styles">
    :dir(ltr) .message {
      margin-left: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-right: 4%; */
    }
	
	:dir(rtl) .message {
      margin-right: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-left: 4%; */
    }
	
	.stealthy{
				display: none;
                left: 0;
                margin: 0;
                max-height: 1px;
                max-width: 1px;
                opacity: 0;
                outline: none;
                overflow: hidden;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: -1;
            }
    .align-ev-input {
      text-align:left;
      margin-left:16px;
      margin-right:16px;
    }
		:dir(rtl) .stealthy{
			display: none;
			right: 0;
			left: auto;
			margin: 0;
			max-height: 1px;
			max-width: 1px;
			opacity: 0;
			outline: none;
			overflow: hidden;
			pointer-events: none;
			position: absolute;
			top: 0;
			z-index: -1;
        }
    	@media all and (-ms-high-contrast:none)
      	{
		oe-input {
          		--paper-input-container-label: {
              			top: -4px;
            		}
          	}
      	}
          app-dialog{
              --iron-input: {
                display:none !important;
              }
          }

          .center-image{
			  margin-left: 30%;
		  }
          .imgstyle{
              height:50px;
              width:100px;
          }
          .descriptionStyle{
            border: 2px solid teal;
            padding: 2px 8px 2px 7px;
            border-radius: 20px;
          }
          .iron-icon-terms{
            height: 30px;
            width: 30px;
          }
          .font-32{
            font-size: 32px;
          }
          .font-22{
            font-size: 22px;
          }
          .imgstyle{
            height: 200px;
            width: 240px;
          }
          .noteSpacing{
            padding-top: 20px; 
            padding-bottom: 10px;
          }
          .widthMixin{
            --dropdownwidth : 115%;
            --dropdownheight : 40px;               
         } 
         .attemptsStyle{
            font-weight: 400;
            font-size: 18px;
            line-height: 30px; 
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: 0.0025em;
         }
         .mb-margin{
            margin:30px;
        }
        .paddingClass{
            padding-right: 10px;
        }
        /* MB style */
        @media (max-width: 479px){
            .mb-margin{
                margin:0px;
            }
            .mb-width{
            width: 100%;
            }
        }
  </style>
  </custom-style>
  <oe-ajax id="crontoValidate" method="post" content-type="application/json" on-response="handleResponse" on-error="handleError"></oe-ajax>
  <div style=""><error-component></error-component></div>
  <div id="main-container" class=" light-background">
    <div class="mdl-grid " style="border-bottom:2px solid #dbdfe8;padding: 20px 0px" >
        <div class="mdl-cell mdl-cell--1-col">
            <div class="content-align-vertical-center mb-margin">
                <iron-icon class="iron-icon-style-s cursor-pointer" icon="icons:arrow-back" on-tap="goToBackpage" style="color:#04859C;"></iron-icon> 
                <oe-i18n-msg class="cursor-pointer font-16"  msgid="b_Back" style="color:#04859C" on-tap="goToBackpage"></oe-i18n-msg>
            </div>
        </div>
        <div class="layout mdl-cell mdl-cell--10-col vertical" style="margin-top:15px;">
        <div class="content-align-center font-32 font-weight-bold mdl-cell mdl-cell--12-col">
            <oe-i18n-msg msgid="l_enterSoftTokenCodeinNBBApp"></oe-i18n-msg>
        </div>
        <div class="font-22 secondary-color content-align-center mdl-cell mdl-cell--12-col">
            <oe-i18n-msg msgid="l_openNBBAppToGetCode"></oe-i18n-msg>
        </div>
        </div>
        <div class="mdl-cell mdl-cell--1-col">
        </div>
    </div>
    <div class="mdl-cell mdl-cell--12-col margin-b-zero">        
        <div style="" >
            <div  class=" content-align-center mb-width" style="padding-top: 42px;">
                <fin-auth-softtoken-otp clear-otp={{clearOtp}}></fin-auth-softtoken-otp>
            </div>
            <div class="content-align-center layout vertical">
                <!--<div class="font-20 font-weight-700 content-align-center mdl-cell mdl-cell--12-col">
                    <oe-i18n-msg msgid="Attempt"></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span><oe-i18n-msg msgid="">{{AttemptNum}}</oe-i18n-msg></span>
                    <span><oe-i18n-msg msgid="/"></oe-i18n-msg></span>
                    <span><oe-i18n-msg ></oe-i18n-msg>{{AttemptLimitNum}}</span>
                </div>-->
                <div class="attemptsStyle content-align-center horizontal layout margin-b-zero mdl-cell mdl-cell--12-col secondary-color">
                    <oe-i18n-msg class="font-weight-700 paddingClass" msgid="l_pleaseNote" ></oe-i18n-msg>
                    <oe-i18n-msg msgid="l_softTokenAuthenticationMsg"></oe-i18n-msg>    
                </div>
                <div class="attemptsStyle content-align-center margin-t-zero mdl-cell mdl-cell--12-col secondary-color">
                    <oe-i18n-msg msgid="l_txnAuthenticationNote5"></oe-i18n-msg>
                </div>
                <div class="font-16 secondary-color content-align-center mdl-cell mdl-cell--12-col">
                    <oe-i18n-msg msgid="l_havingTroubleSigningIn"></oe-i18n-msg>
                </div>
                <div>
                <dropdown-landing class = "widthMixin" borderright = {{borderright}} icon-color = {{iconColor}} fontcolor = {{fontcolor}} dropdown-bck-color = {{dropdownBckColor}} dropdown-bord-color = {{dropdownBordColor}}
                                     new-height = {{newHeight}} place-holder-name = {{placeHolderName}} dropdownlist = {{dropdownlist}} 
                                     selected-value = {{selectedValue}} disabled={{proceedFlag}}  disabled-prop = true ></dropdown-landing>
                </div>
            </div>

        </div>
        <!--<paper-button class="mdl-cell--5-col primary-button" >
					 <oe-i18n-msg msgid="l_proceed"></oe-i18n-msg>
				</paper-button> -->
        
    </div>
    <div class="">
        <div class=" light-background" style="height: 35%;padding-left: 3%;">
            <div class="content-align-center font-16 mdl-cell mdl-cell--12-col teal-color" style="padding-top: 2%;" on-tap="resetMpinFunction">
                <oe-i18n-msg msgid="l_resetMpinAndAdvancedSecurityOptions" class="cursor-pointer" style="
                text-decoration: underline;"></oe-i18n-msg>
            </div>
        </div>
        <div class="mdl-cell--12-col mdl-grid light-background"></div>
        <!-- component for the footer -->
        <fin-page-footer/>
    </div>
    

  </div> 

  `;
Polymer({
    is: 'fin-auth-softtoken',
    _template: template,
    properties: {
        selectedFlag: {
            type: Boolean,
            notify: true,
            value: false
        },
        selectedModePage:{
            type:Number,
            notify:true,
            observer:'setDropdownList'
        },
        selectedPage: {
            type: Number,
            notify: true 
        },
        authModeResponse: {
            type: Object,
            notify: true
        },
        crontoData:{
            type: String,
            value: '',
            notify: true,
        },
        dataBody:{
            type: Object,
            notify: true
        },
        qrResponse:{
            type: Object,
            notify: true,
            observer:'_checkSuccess'
        },
        selectedFlag: {
            type: Boolean,
            notify: true 
        },
        AttemptNum: {
            type: Number,
            notify: true,
            value:1
        },
        AttemptLimitNum: {
            type: Number,
            notify: true,
            value:3
        },
        dropdownlist: {
            type: Array,
            notify: true
        },
        placeHolderName: {
            type: String,
            notify: true
        },
        newHeight: {
            type: String,
            notify: true
        },
        dropdownBckColor: {
            type: String,
            notify: true
        },
        dropdownBordColor: {
            type: String,
            notify: true
        },
        fontcolor: {
            type: String,
            notify: true
        },
        borderright: {
            type: String,
            notify: true
        },
        iconColor: {
            type: String,
            notify: true
        },
        authModeBody: {
            type: Object,
            notify: true 
        },
        authSuccess: {
            type: Boolean,
            notify: true,
            value: false
        },
        authMethods: {
            type: Array,
            notify: true,
            observer:'_authmethodsChange'
        },
        tokenOtp:{
            type: String,
            notify: true,
            observer:'_checkData'
        },
        softtokenOtp:{
            type: String,
            notify: true,
            observer:'_checkData'
        },
        authModeList: {
            type: Array,
            notify: true,
            observer:''
        },
        tempList: {
            type: Array,
            notify: true 
        },
        selectedValue: {
            type: String,
            notify: true 
        },
        resetMpin:{
            type: Boolean, 
            notify: true 
        }, 
        clearOtp: {
            type: Boolean,
            notify: true 
        }
    },
    ready: function() { 
    },
    attached: function() {
         
        this.placeHolderName = "Choose another method"
        this.newHeight = "40px";
        this.dropdownBckColor = "white !important";
        this.dropdownBordColor = "#003D4C";
        this.fontcolor = "#003D4C";
        this.borderright = "1px";
        this.iconColor = "#003D4C";
        this.proceedFlag = true;
        this.addEventListener('stknotpValue', this.otpValueFunction.bind(this));
  },
  goToBackpage(){ 
    this.authSuccess=false; 
    this.selectedPage=0;
    this.selectedValue = "";    
  },
  otpValueFunction(e){ 
      this.tokenOtp=e.detail.data; 
  },
  _checkData(){
    if(this.tokenOtp!="" && this.tokenOtp!=undefined){
        //this.authSuccess=true;
        this.softtokenOtp=this.tokenOtp;        
        this.clearOtp=true;
    } 
  },
  setDropdownList(){
    this.dropdownlist=[];
    if(this.selectedModePage==2){
        if(this.authModeResponse !="" && this.authModeResponse !=undefined){  
            for (let i=0;i<this.authModeList.length;i++){
                if(this.authModeList[i].cmCode!= "STKN"){ 
                    this.dropdownlist.push({label: this.authModeList[i].codeDescription, id: this.authModeList[i].cmCode});                    
                }
            }
        }
    }
  },
  resetMpinFunction(){
    clearInterval(this.interval);
    clearTimeout(this.timeOut);
    this.resetMpin=true;
    this.selectedPage=0;  
  } 
});